import type { Account } from '@/api/generated/model';

/** Sum of balances across checking accounts (banking pillar hero primary metric). */
export function computeCheckingBalance(accounts: Account[]): number {
  return accounts
    .filter((account) => account.type === 'checking')
    .reduce((sum, account) => sum + account.balance, 0);
}
